<app-page-title [title]="'Forgot Password'"></app-page-title>
<div class="form-container">
    <div class="row">
        <div class="col-md-6">
            <p>Enter the email address associated with your {{brandName}} Account, then click Reset Password. We will email you a link to a page where you can create a new password.</p>
            <form
                name="forger-password-form"
                [formGroup]="userForm"
                (ngSubmit)="onSubmit()"
            >
                <div class="form-group">
                    <input
                        type="email"
                        class="form-control"
                        name="email"
                        placeholder="Enter email"
                        formControlName="email"
                        autofocus
                    />
                    <small
                        class="error"
                        *ngIf="f.email.dirty && f.email.errors?.required"
                    >Please enter in an email.</small>
                </div>
                <div class="form-group">
                    <button
                        name="confirmationYesBtn"
                        type="submit"
                        class="btn btn-primary"
                    >
                        Reset Password
                    </button>
                </div>
                <div *ngIf="formSubmitted == true">
                    <div class="row">
                        <div class="col-md-12">
                            <p>Please go to your inbox and follow the instructions to reset your password.</p>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-5">
            <app-feature-list></app-feature-list>
        </div>
    </div>
    <app-modal
        #emailExists
        title="Error"
        body={{emailExistBody}}
    >
    </app-modal>
</div>
